// react
import React, {
    useCallback,
    useEffect,
    useRef,
    useState,
} from 'react';

// third-party
import classNames from 'classnames';
import { useHistory, withRouter } from 'react-router-dom';

// application
import shopApi from '../../api/shop';
import Suggestions from './Suggestions';
import { Cross20Svg, Search20Svg } from '../../svg';

function useCategories() {
    const [categories, setCategories] = useState([]);

    // useEffect(() => {
    //     let canceled = false;

    //     const treeToList = (categories, depth = 0) => (
    //         categories.reduce(
    //             (result, category) => [
    //                 ...result,
    //                 { depth, ...category },
    //                 ...treeToList(category.children || [], depth + 1),
    //             ],
    //             [],
    //         )
    //     );

    //     shopApi.getCategories({ depth: 1 }).then((categories) => {
    //         if (canceled) {
    //             return;
    //         }

    //         setCategories(treeToList(categories));
    //     });

    //     return () => {
    //         canceled = true;
    //     };
    // }, [setCategories]);

    return categories;
}

function Search(props) {
    const {
        context,
        className,
        inputRef,
        onClose,
        location,
    } = props;
    const internalInputRef = useRef(null);
    const resolvedInputRef = inputRef || internalInputRef;
    const [cancelFn, setCancelFn] = useState(() => () => { });
    const [suggestionsOpen, setSuggestionsOpen] = useState(false);
    const [hasSuggestions, setHasSuggestions] = useState(false);
    const [suggestedProducts, setSuggestedProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const searchCache = useRef({});
    const [query, setQuery] = useState('');
    const [category, setCategory] = useState('3');
    const [wh_id, setWh_id] = useState(3);

    const history = useHistory()
    const submitHandler = (e) => {
        e.preventDefault();
        e.target.reset();
        history.push(`/shop/category?name=${query}&wh_id=${wh_id}`);
    }
    const categories = useCategories();
    useEffect(() => {
        if (categories) {
            setWh_id(categories[0]?.id)
        }
    }, [])
    // console.log(categories)
    // console.log(wh_id)
    const wrapper = useRef(null);
    const close = useCallback(() => {
        if (onClose) {
            onClose();
        }

        setSuggestionsOpen(false);
    }, [onClose]);

    const handleCloseSuggestionsAndClear = useCallback(() => {
        cancelFn();
        setQuery('');
        setHasSuggestions(false);
        setSuggestedProducts([]);
        setSuggestionsOpen(false);
        if (resolvedInputRef && resolvedInputRef.current && typeof resolvedInputRef.current.blur === 'function') {
            resolvedInputRef.current.blur();
        }
        if (onClose) {
            onClose();
        }
    }, [cancelFn, onClose, resolvedInputRef]);

    // Close suggestions when the location has been changed.
    useEffect(() => close(), [close, location]);

    // Close suggestions when a click has been made outside component.
    useEffect(() => {
        const onGlobalClick = (event) => {
            if (wrapper.current && !wrapper.current.contains(event.target)) {
                close();
            }
        };

        document.addEventListener('mousedown', onGlobalClick);

        return () => document.removeEventListener('mousedown', onGlobalClick);
    }, [close]);

    // Cancel previous typing.
    useEffect(() => () => cancelFn(), [cancelFn]);

    const handleFocus = () => {
        if (query.trim().length >= 3 && hasSuggestions) {
            setSuggestionsOpen(true);
        }
    };

    const handleChangeCategory = (event) => {
        setCategory(event.target.value);
        setWh_id(Number(event.target.value));
    };

    const handleChangeQuery = (event) => {
        let canceled = false;
        let timer;

        const newCancelFn = () => {
            canceled = true;
            clearTimeout(timer);
        };

        event.preventDefault();
        const nextQuery = event.target.value;
        setQuery(nextQuery);

        const trimmed = nextQuery.trim();

        // Muncul setelah minimal 3 huruf
        if (trimmed.length < 3) {
            setHasSuggestions(false);
            setSuggestedProducts([]);
            setSuggestionsOpen(false);
            setIsLoading(false);
        } else {
            const cacheKey = `${trimmed.toLowerCase()}_${category}`;

            // Jika hasil sudah ada di cache, tampilkan langsung secara instan (0ms)
            if (searchCache.current[cacheKey]) {
                const cachedProducts = searchCache.current[cacheKey];
                setSuggestedProducts(cachedProducts);
                setHasSuggestions(true);
                setSuggestionsOpen(true);
                setIsLoading(false);
            } else {
                setIsLoading(true);
                setHasSuggestions(true);
                setSuggestionsOpen(true);

                // Debounce dioptimalkan menjadi 250ms (jauh lebih cepat daripada 1000ms sebelumnya)
                timer = setTimeout(() => {
                    shopApi.getSuggestions(trimmed, category)
                        .then((products) => {
                            if (canceled) {
                                return;
                            }
                            const items = Array.isArray(products) ? products : [];
                            searchCache.current[cacheKey] = items;
                            setSuggestedProducts(items);
                            setHasSuggestions(true);
                            setSuggestionsOpen(true);
                            setIsLoading(false);
                        })
                        .catch((error) => {
                            if (canceled) {
                                return;
                            }
                            console.error("API Error:", error);
                            const fallback = error.response?.data?.response;
                            const items = Array.isArray(fallback) ? fallback : null;
                            setSuggestedProducts(items);
                            setHasSuggestions(true);
                            setSuggestionsOpen(true);
                            setIsLoading(false);
                        });
                }, 250);
            }
        }

        setCancelFn(() => newCancelFn);
    };

    const handleBlur = () => {
        setTimeout(() => {
            if (!document.activeElement || document.activeElement === document.body) {
                return;
            }

            // Close suggestions if the focus received an external element.
            if (wrapper.current && !wrapper.current.contains(document.activeElement)) {
                close();
            }
        }, 10);
    };

    // Close suggestions when the Escape key has been pressed.
    const handleKeyDown = (event) => {
        // Escape.
        if (event.which === 27) {
            close();
        }
    };

    const rootClasses = classNames(`search search--location--${context}`, className, {
        'search--suggestions-open': suggestionsOpen,
        'search--has-suggestions': hasSuggestions,
    });

    const closeButton = context !== 'mobile-header' ? '' : (
        <button className="search__button search__button--type--close" type="button" onClick={close}>
            <Cross20Svg />
        </button>
    );

    const categoryOptions = categories.map((category) => (
        <option key={category.id} value={category.id} onClick={(e) => setWh_id(Number(e.target.value))}>
            {'\u00A0'.repeat(4 * category.depth)}
            {category.name}
        </option>
    ));

    return (
        <div className={rootClasses} ref={wrapper} onBlur={handleBlur}>
            <div className="search__body">
                <form className="search__form" onSubmit={submitHandler}>
                    {/* {context === 'header' && (
                        <select
                            className="search__categories"
                            aria-label="Category"
                            value={category}
                            onFocus={close}
                            onChange={handleChangeCategory}
                        >
                            <option value="[all]">Semua toko</option>
                            {categoryOptions}
                        </select>
                    )} */}
                    <input
                        ref={resolvedInputRef}
                        onChange={handleChangeQuery}
                        onFocus={handleFocus}
                        onKeyDown={handleKeyDown}
                        value={query}
                        className="search__input"
                        name="search"
                        placeholder={context === 'mobile-header' ? 'Cari produk bangunan' : 'Cari Berdasarkan Nama Produk'}
                        aria-label="Site search"
                        type="text"
                        autoComplete="off"
                    />
                    <button className="search__button search__button--type--submit" type="submit" aria-label="Cari Produk">
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <circle cx="11" cy="11" r="8" />
                            <line x1="21" y1="21" x2="16.65" y2="16.65" />
                        </svg>
                    </button>
                    {closeButton}
                    <div className="search__border" />
                </form>

                <Suggestions
                    className="search__suggestions"
                    context={context}
                    products={suggestedProducts}
                    isLoading={isLoading}
                    onItemClick={handleCloseSuggestionsAndClear}
                    onAddToCartSuccess={handleCloseSuggestionsAndClear}
                    query={query}
                    wh_id={wh_id}
                />
            </div>
        </div>
    );
}

export default withRouter(Search);
